import { ArrowLeftIcon, BoltIcon, BoltSlashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { Button } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './config'

const inputGroups: any = {
  'General Info': [
    'Company',
    'WebsiteUrl',
    'FirstName',
    'MiddleName',
    'LastName',
    'Title',
    'Street',
    'City',
    'State',
    'Zip',
    'LicenseNo',
    'CompanyLicenseNo',
    'BranchID',
  ],
  'Contact Info': ['HomePhone', 'OtherPhone', 'Pager', 'WorkPhone', 'MobilePhone', 'Fax', 'EMail', 'EMail2', 'EMail3'],
  'Tax ID / NMLS': ['CompanyEIN', 'CompanyNMLSID', 'ContactNMLSID', 'Notes'],
  'Entity Information': ['EntityState', 'EntityType'],
}

export const PartyFieldConfig = ({ onBack }: { onBack: () => void }) => {
  const partyInputs = defaultInputs()

  const [isLoading, setLoading] = useState(true)
  const [isChanged, setChanged] = useState<boolean>()
  const [data, setData] = useState<Record<string, any>>({})

  useEffect(() => {
    setLoading(true)
    getAdminConfig('partyFieldConfig')
      .then((res) => {
        if (!res) return
        setData(res)
      })
      .finally(() => setLoading(false))
  }, [])

  const onVisible = (key: string, value: any, props: 'visible' | 'required') => {
    const newData = cloneDeep(data)
    if (!newData[key]) newData[key] = {}
    newData[key][props] = value
    setData(newData)
    setChanged(true)
  }

  const onSubmit = async () => {
    setLoading(true)
    await setAdminConfig('partyFieldConfig', data)
    setLoading(false)
    setChanged(false)
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <h1
        className="text-2xl font-variation-settings-600 flex gap-1 items-center cursor-pointer text-shade-blue hover:underline"
        onClick={onBack}
      >
        <ArrowLeftIcon className="w-3 h-3" />
        <span className="ml-2 uppercase text-sm">Back</span>
      </h1>
      <h2 className="text-2xl font-bold flex items-center mb-3">Party Field Configuration</h2>
      <div className="grid grid-cols-3 mt-4 gap-2 mb-4">
        {Object.keys(inputGroups).map((section, index: number) => {
          return (
            <>
              <div className="col-span-full">
                <RenderInput
                  Key={`section${index}`}
                  input={{
                    inputType: 'section',
                    title: `${index + 1}. ${section}`,
                  }}
                  onChange={() => {}}
                />
              </div>
              {(inputGroups as any)[section].map((key: string, subIndex: number) => {
                const { visible = true, required = false } = data[key] || {}
                // const Icon = visible ? EyeIcon : EyeSlashIcon
                const RequiredIcon = required ? BoltIcon : BoltSlashIcon

                return (
                  <div className={`flex justify-between items-center`} key={section + key}>
                    <p className={`text-sm ${visible ? '' : 'line-through opacity-60'}`}>
                      {subIndex + 1}. {partyInputs[key].title}
                    </p>
                    <div className="flex gap-2 items-center">
                      {/* <span
                        className={`btn-icon ${visible ? '' : 'opacity-60'}`}
                        onClick={() => onVisible(section, key, !visible, 'visible')}
                      >
                        <Icon className="w-4 h-4" />
                      </span> */}
                      <span
                        className={`btn-icon ${required ? '' : 'opacity-60'}`}
                        onClick={() => onVisible(key, !required, 'required')}
                      >
                        <RequiredIcon className="w-4 h-4" />
                      </span>
                    </div>
                  </div>
                )
              })}
            </>
          )
        })}
      </div>

      <div className="flex flex-row justify-center gap-4">
        <Button onClick={onSubmit} loading={isLoading} disabled={!isChanged}>
          Save
        </Button>
      </div>

      <SaveChanges show={isChanged} label="Save Changes" onSave={onSubmit} />
    </div>
  )
}
